import React, { Fragment, useState, useEffect } from "react";
import { Button, Image, Table, Modal, Row, Col } from "react-bootstrap";
import moment from "moment";
import OrderDescModelBody from "../../SuperAdminOrders/SuperAdminOrdersTable/OrderDescModelBody";
import BasicPagination from "../../../../Pagination/Pagination";
import OrderEditModelBody from "./Orders/OrderEditModelBody";
import isEmpty from "../../../../../store/validation/is-Empty";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  create_and_update_restaurant,
  get_new_subscription_for_vendor,
} from "../../../../../store/actions/authAction";
import { setVendorAccess } from "../../../../../store/actions/vendorAccessActions";
import { NOTAVAILABLEIMAGE } from "../../../../../enums/GlobalEnums";
import { NEW_PAYMENT_TYPE } from "../../../../../enums/OrderEnums";
import NoContent from "../../../../reusableComponents/NoContentComponent";
import { ITEMTYPEVEG } from "../../../../../enums/OrderEnums";
import ReactHtmlParser from "react-html-parser";
import {
  CAR_COLORS,
  SPICELEVEL,
  SALTLEVEL,
  SUGARLEVEL,
  FATLEVEL,
  MEATCOOKLEVEL,
  EGGCOOKLEVEL,
} from "../../../../../enums/OrderEnums";
import {
  StatusColorsOrdersBadges,
} from "../../../../../enums/GlobalEnums";
const OrderingPageComponent = (props) => {
  const [vtype, viewType] = useState(3);
  const [orderData, setOrderData] = useState({});
  const [MrDetail, setMrDetail] = useState({ MrDetail: false });
  const viewOrderInDetail = () => setMrDetail({ MrDetail: !MrDetail.MrDetail });

  useEffect(() => {
    setPage(1);
    setStart(0);
    setEnd(10);
  }, [props.search]);

  const [insidePageTab, setinsidePageTab] = useState(10);

  const onClickSearch = (value) => {
    setinsidePageTab(value);
    props.onClickSearch();
  };

  const calcDate = (order) => {
    return order?.orderDetails?.later_date || order?.orderDetails?.createdAt;
  };
  const calcItemsLength = (order) => {
    let count = 0;

    for (let i = 0; i < order?.order_items.length; i++) {
      if (
        order?.order_items[i].isSubstituted ||
        order?.order_items[i].isCancelled
      ) {
      } else {
        count += 1;
      }
    }
    return count;
  };

  const [page, setPage] = useState(1);
  const [start, setStart] = useState(0);
  const [end, setEnd] = useState(10);
  const handleBatchChange = (pageNo) => {
    window.scrollTo(0, 0);
    var calcStart = pageNo * 10 - 10;
    setStart(calcStart);
    setEnd(pageNo * 10);
    setPage(pageNo);
  };

  const [order, setOrder] = useState([]);

  let filteredData = props.data.filter(
    (itemData) => itemData?.transactionDetails.length > 0
  );

  filteredData = filteredData?.filter((item) => {
    return (
      item?.restaurant_id?.restaurant_name
        ?.toLowerCase()
        .includes(props.search?.toLowerCase()) ||
      item?.order_id?.includes(props.search)
    );
  });

  if (insidePageTab === 0) {
    filteredData = filteredData?.filter(
      (ele) => ele.order_type === insidePageTab
    );
  } else if (insidePageTab === 1) {
    filteredData = filteredData?.filter(
      (ele) => ele.order_type === insidePageTab
    );
  } else if (insidePageTab === 2) {
    filteredData = filteredData?.filter(
      (ele) => ele.order_type === insidePageTab
    );
  } else if (insidePageTab === 3) {
    filteredData = filteredData?.filter(
      (ele) => ele.order_type === insidePageTab
    );
  } else if (insidePageTab === 7) {
    filteredData = filteredData?.filter(
      (ele) => ele.order_type === insidePageTab
    );
  } else if (insidePageTab === 10) {
    filteredData = filteredData;
  }

  if (props.sortBy === "Latest") {
    filteredData = filteredData?.sort(
      (a, b) => new Date(calcDate(b)) - new Date(calcDate(a))
    );
  } else if (props.sortBy === "Oldest") {
    filteredData = filteredData?.sort(
      (a, b) => new Date(calcDate(a)) - new Date(calcDate(b))
    );
  } else if (props.sortBy === "A-Z") {
    filteredData = filteredData?.sort((a, b) =>
      a.restaurant_id?.restaurant_name > b.restaurant_id?.restaurant_name
        ? 1
        : -1
    );
  } else if (props.sortBy === "Z-A") {
    filteredData = filteredData?.sort((a, b) =>
      b.restaurant_id?.restaurant_name > a.restaurant_id?.restaurant_name
        ? 1
        : -1
    );
  }

  if (!isEmpty(props.filterBy)) {
    if (props?.filterBy?.status)
      filteredData = filteredData?.filter(
        (ele) => ele.order_status === props?.filterBy?.status
      );
    if (props?.filterBy?.paymentStatus)
      filteredData = filteredData?.filter(
        (ele) => ele.payment_status === props?.filterBy?.paymentStatus
      );
    if (props?.filterBy?.paymentType)
      filteredData = filteredData?.filter(
        (ele) => ele.payment_method === props?.filterBy?.paymentType
      );
  }

  // if (props.sortByDay !== 4) {
  //   filteredData = filteredData?.filter((item) => {
  //     return (
  //       (props.startDay <= moment(item.createdAt).format("YYYY-MM-DD") ||
  //         props.startDay <= moment(item.updatedAt).format("YYYY-MM-DD")) &&
  //       (moment(item.createdAt).format("YYYY-MM-DD") <= props.endDay ||
  //         moment(item.updatedAt).format("YYYY-MM-DD") <= props.endDay)
  //     );
  //   });
  // }

  // if (props.orderFilter.order_type !== 10 && props.clickedSearch) {
  //   filteredData = filteredData.filter((item) => {
  //     return item && item.order_type === props.orderFilter.order_type;
  //   });
  // }
  // if (props.orderFilter.order_status !== 10 && props.clickedSearch) {
  //   filteredData = filteredData.filter((item) => {
  //     return item && item.order_status === props.orderFilter.order_status;
  //   });
  // } 

  const dispatch = useDispatch();
  const history = useHistory();
  const onViewDashboard = (orders) => {
    history.push({
      pathname: `/orderdashboard/editorder-request/${orders?._id}`,
      state: { orderDetails: orders },
    });
    console.log(orders?._id,"id")
    // history.push(`/orderdashboard/editorder-request/${id}`);
  };

  const vendorDashboard = (orders) => () => {
    dispatch(create_and_update_restaurant({ vendor_id: orders?.vendor_id }));
    dispatch(get_new_subscription_for_vendor({ vendor_id: orders?.vendor_id }));
    dispatch(setVendorAccess(orders?.vendor_id, onViewDashboard(orders)));
  };
  console.log(filteredData, "filterdata");
  return (
    <React.Fragment>
      {console.log(insidePageTab)}
      <div className="row super_admin_all_users_toggle_button-tab">
        <div className="col-9 super_admin_all_users_toggle_button-tab">
          <div className="Right-side-heading-text ml-0">
            <div className="d-flex align-items-center">
              <Button
                variant="link"
                className={`px-0 mr-4 text-grayLink f12-500 ${
                  insidePageTab === 10 ? "active" : ""
                }`}
                onClick={() => {
                  props.onChangeOrderState("order_type", 10);
                  onClickSearch(10);
                }}
              >
                All
              </Button>
              <Button
                variant="link"
                className={`px-0 mr-4 text-grayLink f12-500 ${
                  insidePageTab === 0 ? "active" : ""
                }`}
                onClick={() => {
                  props.onChangeOrderState("order_type", 0);
                  onClickSearch(0);
                }}
              >
                Take Away
              </Button>
              <Button
                variant="link"
                className={`px-0 mr-4 text-grayLink f12-500 ${
                  insidePageTab === 2 ? "active" : ""
                }`}
                onClick={() => {
                  props.onChangeOrderState("order_type", 2);
                  onClickSearch(2);
                }}
              >
                Skip the Line
              </Button>
              <Button
                variant="link"
                className={`px-0 mr-4 text-grayLink f12-500 ${
                  insidePageTab === 3 ? "active" : ""
                }`}
                onClick={() => {
                  props.onChangeOrderState("order_type", 3);
                  onClickSearch(3);
                }}
              >
                Dine-In
              </Button>
              <Button
                variant="link"
                className={`px-0 mr-4 text-grayLink f12-500 ${
                  insidePageTab === 1 ? "active" : ""
                }`}
                onClick={() => {
                  props.onChangeOrderState("order_type", 1);
                  onClickSearch(1);
                }}
              >
                Curbside
              </Button>
              <Button
                variant="link"
                className={`px-0 mr-4 text-grayLink f12-500 ${
                  insidePageTab === 7 ? "active" : ""
                }`}
                onClick={() => {
                  props.onChangeOrderState("order_type", 7);
                  onClickSearch(7);
                }}
              >
                Home Delivery
              </Button>
            </div>
          </div>
        </div>
      </div>
      <div className="col-12 p-0 user-table-reusable-superadmin table-responsive ">
        <Table className="enMinWidth900">
          <thead>
            <tr className="super_admin_all_users_table_head">
              <th style={{ width: "10%" }} className="f12-700">
                Order <br /> Type
              </th>
              <th style={{ width: "10%" }} className="f12-700">
                Order ID
              </th>
              <th
                style={{ width: "10%", textAlign: "center" }}
                className="f12-700"
              >
                Restaurant
                <br /> Name
              </th>
              <th style={{ width: "10%" }} className="f12-700">
                No. <br />
                Items
              </th>
              <th style={{ width: "10%" }} className="f12-700">
                Amount / <br />
                Payment
              </th>
              <th style={{ width: "10%" }} className="f12-700">
                Order <br />
                Reference
              </th>
              <th style={{ width: "10%" }} className="f12-700">
                Status
              </th>
              <th style={{ width: "15%" }} className="f12-700">
                Date/
                <br />
                Time
              </th>
              <th style={{ width: "15%" }} className="f12-700">
                Actions
              </th>
            </tr>
          </thead>

          {filteredData?.length ? (
            filteredData
              .sort((a, b) => {
                // if (sort === 1) {
                //   if (new Date(calcDate(a)) < new Date(calcDate(b))) return -1;
                //   if (new Date(calcDate(a)) > new Date(calcDate(b))) return 1;
                //   return 0;
                // } else if (sort === 2) {
                if (new Date(calcDate(a)) < new Date(calcDate(b))) return 1;
                if (new Date(calcDate(a)) > new Date(calcDate(b))) return -1;
                return 0;
                // }
              })
              ?.slice(start, end)
              .map((order, index) => (
                <TableBody
                  key={index}
                  order={order}
                  vendorDashboard={vendorDashboard}
                  calcItemsLength={calcItemsLength}
                  setOrderData={setOrderData}
                  viewType={viewType}
                  viewOrderInDetail={viewOrderInDetail}
                />
              ))
          ) : (
            <NoContent />
          )}
        </Table>
        {filteredData?.length !== 0 ? (
          <BasicPagination
            totalRecords={filteredData.length}
            limit={10}
            batch={page}
            onBatchChange={(e) => handleBatchChange(e)}
          />
        ) : (
          <></>
        )}
      </div>

      <Modal
        show={MrDetail.MrDetail}
        onHide={() => {
          viewOrderInDetail();
        }}
        centered
        size={vtype === 3 ? "md" : "xl"}
      >
        <Modal.Header className="border-0 pl-4" closeButton>
          <Modal.Title className="f24-700">
            {vtype === 1 && "View Order Details"}
            {vtype === 2 && "Edit Order Details"}
            {/*{vtype === 3 && "User Location"}
            {vtype === 4 && "Substitute Item"}
            {vtype === 5 && "Select Items To Substitute"}
            {vtype === 6 && "Update Availability of Item"} */}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-4 f16-500">
          <div className="">
            {vtype === 1 && <OrderDescModelBody allData={orderData} />}
          </div>
          {vtype === 2 && <OrderEditModelBody allData={orderData} />}
          {/* <EditUser
                            data={currentUserData}
                            CloseEdit={handleCloseEdit}
                          /> */}
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
};

const TableBody = ({
  key,
  order,
  vendorDashboard,
  calcItemsLength,
  setOrderData,
  viewType,
  viewOrderInDetail,
}) => {
  const [TrDetail, setTrDetail] = useState(false);
  const showTr = () => setTrDetail(!TrDetail);

  const getAddOns = (data) => {
    let addOnsNames = [];
    for (let i = 0; i < data.length; i++) {
      for (let j = 0; j < data[i].options.length; j++) {
        addOnsNames.push(data[i].options[j].name);
      }
    }
    return addOnsNames.toString();
  };

  const prepareLevels = (data) => {
    let levelNames = [];
    if (data.spice_level) {
      let spice = `Spice : ${SPICELEVEL[data.spice_level.level].title}`;
      //  + "/" + cookLevels.spice;
      levelNames.push(spice);
    }

    if (data.salt_level) {
      let salt = `<br/>Salt : ${SALTLEVEL[data.salt_level.level].title}`;
      //  + "/" + cookLevels.salt;
      levelNames.push(salt);
    }

    if (data.sugar_level) {
      let sugar = `<br/>Sugar : ${SUGARLEVEL[data.sugar_level.level].title}`;
      //  + "/" + cookLevels.sugar;
      levelNames.push(sugar);
    }

    if (data.fat_level) {
      let fat = `<br/>fat/oil/fried : ${FATLEVEL[data.fat_level.level].title}`;
      //  + "/" + cookLevels.fat;
      levelNames.push(fat);
    }

    if (data.meat_cook_level) {
      let meat = `<br/>Meat : ${
        MEATCOOKLEVEL[data.meat_cook_level.level].title
      }`;
      //  + "/" + cookLevels.meat;
      levelNames.push(meat);
    }

    if (data.egg_cook_level) {
      let egg = `<br/>Egg : ${
        EGGCOOKLEVEL[data.egg_cook_level.level].title
      }<br/>`;
      //  + "/" + cookLevels.egg;
      levelNames.push(egg);
    }
    return levelNames.toString();
  };
  return (
    <>
      <tbody>
        <tr className="super_admin_all_users_table_body">
          <td className="p-0 w-100">
            <table className="w-100 HideShowTable">
              <tbody>
                <tr
                  className="cursor super_admin_user_view_inside_table_body"
                  onClick={showTr}
                  key={key}
                >
                  <td style={{ width: "10%" }}>
                    {/* <div className="f12-400">Icon</div> */}
                    <img
                      src={
                        order && order?.order_type === 0
                          ? require("../../../../../assets/images/superadmin/ordericon/takeaway.svg")
                          : order && order?.order_type === 1
                          ? require("../../../../../assets/images/superadmin/ordericon/curb side.svg")
                          : order && order?.order_type === 3
                          ? require("../../../../../assets/images/superadmin/ordericon/dine in.svg")
                          : order && order?.order_type === 2
                          ? require("../../../../../assets/images/superadmin/ordericon/skip the line.svg")
                          : order && order?.order_type === 7
                          ? require("../../../../../assets/images/superadmin/ordericon/delivery.svg")
                          : ""
                      }
                      alt={
                        order && order?.order_type === 0
                          ? "Takeaway"
                          : order && order?.order_type === 1
                          ? "Curb Side"
                          : order && order?.order_type === 2
                          ? "Skip The Line"
                          : order && order?.order_type === 3
                          ? "Dine In"
                          : order && order?.order_type === 7
                          ? "Home Delivery"
                          : ""
                      }
                      title={
                        order && order?.order_type === 0
                          ? "Takeaway"
                          : order && order?.order_type === 1
                          ? "Curb Side"
                          : order && order?.order_type === 2
                          ? "Skip The Line"
                          : order && order?.order_type === 3
                          ? "Dine In"
                          : order && order?.order_type === 7
                          ? "Home Delivery"
                          : ""
                      }
                      width="35px"
                    />
                  </td>
                  <td style={{ width: "10%" }}>
                    <div className="f12-400">{order?.order_id}</div>
                  </td>
                  <td style={{ width: "10%", textAlign: "center" }}>
                    <div>
                      <div>
                        <Image
                          src={
                            (order &&
                              order?.restaurant_id &&
                              order?.restaurant_id?.logo_url) ||
                            NOTAVAILABLEIMAGE
                          }
                          alt="restaurant logo"
                          title="restaurant logo"
                          className="enIMG28Round"
                          style={{
                            maxWidth: "90px",
                            width: "auto",
                          }}
                        />
                      </div>
                      <div className="pl-2">
                        <div className="f12-400">
                          {order &&
                            order?.restaurant_id &&
                            order?.restaurant_id?.restaurant_name}
                        </div>
                      </div>
                    </div>
                  </td>
                  <td style={{ width: "10%" }}>
                    <div className="f12-400">{calcItemsLength(order)}</div>
                  </td>
                  <td style={{ width: "10%" }}>
                    <div className="f12-400">
                      ₹ {order && order?.total_amount?.toFixed(2)}
                      <br />
                      <div
                        className="f12-500"
                        style={{
                          color: `${
                            order && order?.payment_status === 1
                              ? "green"
                              : order && order?.payment_status === 0
                              ? "red"
                              : "red"
                          }`,
                        }}
                      >
                        {" "}
                        {order && order?.payment_status === 1
                          ? "PAID"
                          : order && order?.payment_status === 0
                          ? "UNPAID"
                          : order?.payment_status === 3
                          ? "FAILURE"
                          : "N/A"}
                      </div>
                      {/* <div>
            {" "}
            {order && order?.payment_method === 0
              ? "COD"
              : order?.payment_method === 1
              ? "UPI"
              : order?.payment_method === 2
              ? "Paytm"
              : order?.payment_method === 3
              ? "Debit Card"
              : order?.payment_method === 4
              ? "Credit Card"
              : order?.payment_method === 5
              ? "NetBanking"
              : order?.payment_method === 6
              ? "Pay Later"
              : order?.payment_method === 7
              ? "Wallet"
              : order?.payment_method === 8
              ? "External Wallet"
              : order?.payment_method === 9
              ? "Cash"
              : null}
          </div> */}
                      {/* <div className="f12-500">
            {order?.transactionDetails.map((data, index) => {
              return <>{NEW_PAYMENT_TYPE[data?.paymentType]} </>;
            })}
          </div> */}
                      <div className="f12-500">
                        {order?.splitPayment ? (
                          <>Split Payment</>
                        ) : (
                          NEW_PAYMENT_TYPE[order?.payment_method]
                        )}
                      </div>
                    </div>
                  </td> 
                  <td style={{ width: "10%" }}>
                    <div className="f12-400">
                      {" "}
                      <p className="f12-500">
                        {order && order?.order_type === 1 ? (
                          <Fragment>
                            {order?.curb_side_details?.vehical_number} <br />
                            <span style={{ fontSize: ".75rem" }}>
                              {order &&
                                order?.curb_side_details &&
                                order?.curb_side_details?.model}{" "}
                              {order &&
                                order?.curb_side_details &&
                                order?.curb_side_details?.make}
                              |{" "}
                              {order &&
                                order?.curb_side_details &&
                                order?.curb_side_details?.color}
                            </span>{" "}
                          </Fragment>
                        ) : (
                          <Fragment>
                            {order && order?.order_type === 3
                              ? order?.dine_in_details?.table_number
                              : "N/A"}
                          </Fragment>
                        )}
                      </p>
                    </div>
                  </td>
                  <td style={{ width: "10%" }}>
                    <div className="f12-400">
                      {/* <p className="f12-400">Status:&nbsp;</p> */}
                      <span
                        style={{
                          width:"13px",
                          height:"13px",
                          borderRadius:"50%",
                          display:"inline-block",
                          WebkitBorderRadius:"50%",
                          MozBorderRadius:"50%",
                          backgroundColor:
                            StatusColorsOrdersBadges[
                              order?.order_status
                            ].color,
                        }}
                      ></span>
                      {order && order?.order_status === 0
                        ? "Pending"
                        : order?.order_status === 1
                        ? "Confirmed"
                        : order?.order_status === 2
                        ? "Getting Prep"
                        : order?.order_status === 3 &&
                          order &&
                          order?.order_type === 3
                        ? "Food Plating"
                        : order?.order_status === 3
                        ? "Packing"
                        : order?.order_status === 4 &&
                          order &&
                          order?.order_type === 3
                        ? "Ready for Dine-in"
                        : order?.order_status === 4 && order?.order_type === 7
                        ? "Ready For Delivery"
                        : order?.order_status === 4
                        ? "Ready To Pick"
                        : order?.order_status === 5 && order?.order_type === 7
                        ? "Out for Delivery"
                        : order?.order_status === 5
                        ? "On The Way"
                        : order?.order_status === 6 &&
                          order &&
                          order?.order_type === 3
                        ? "Served"
                        : order?.order_status === 6
                        ? "Delivered"
                        : order?.order_status === 7
                        ? "Complete"
                        : order?.order_status === 8
                        ? "Cancelled"
                        : null}
                    </div>
                  </td>
                  <td style={{ width: "15%" }}>
                    <div className="f12-400">
                      {" "}
                      {/* {moment(calcDate(order)).format("Do MMMM YYYY")} */}
                      {moment(order?.createdAt).format("Do MMMM YYYY")}
                    </div>
                    <div className="f12-400">
                      {" "}
                      {/* {moment(calcDate(order)).format("hh : mm A")} */}
                      {moment(order?.createdAt).format("hh : mm A")}
                    </div>

                    <br />
                  </td>

                  <td style={{ width: "15%" }}>
                    <div className="enWidth130 d-flex justify-content-end flex-wrap align-items-center">
                      <Button
                        variant="link"
                        className="enIconBtn mr-2 mb-2"
                        // onClick={() => {
                        //   setOrderData(order);
                        //   // viewType(2);
                        //   // viewOrderInDetail();

                        // }}
                        onClick={vendorDashboard(order)}
                      >
                        <Image
                          src={require("../../../../../assets/images/UserManagement/pencil.svg")}
                          alt="View"
                          title="Edit User"
                          fluid
                        />
                      </Button>
                      <Button
                        variant="link"
                        className="enIconBtn mb-2 mr-3 action_icon_padding"
                        onClick={() => {
                          setOrderData(order);
                          viewType(1);
                          viewOrderInDetail();
                        }}
                      >
                        <Image
                          src={require("../../../../../assets/images/UserManagement/eye.svg")}
                          alt="View"
                          title="View"
                          fluid
                        />
                      </Button>{" "}
                    </div>
                  </td>
                </tr>
                {TrDetail && (
                  <>
                    <Row className="mt-3">
                      <Col
                        className="col-3 col-sm-3 col-md-3 text-center"
                        style={{ cursor: "no-drop" }}
                      >
                        {!this?.props?.admin && (
                          <>
                            <h5 className="f12-500">User Location</h5>
                            <br />
                            <center>
                              <img
                                src={require("../../../../../assets/images/superadmin/ordericon/location_red.svg")}
                                width="25px"
                              />
                            </center>
                          </>
                        )}
                      </Col>
                      <Col className="col-3 col-sm-3 col-md-3">
                        <h5 className="f12-500">Order Notes</h5>
                        <br />
                        <p>{order?.notes}</p>
                      </Col>
                      <Col className="col-3 col-sm-3 col-md-3">
                        <h5 className="f12-500">ETR</h5>
                        <br />
                        <p>
                          {order?.reaching_time
                            ? `${order?.reaching_time}min`
                            : "N/A"}
                        </p>
                      </Col>
                      <Col className="col-3 col-sm-3 col-md-3 mt-4 mt-md-0">
                        <div
                          className="container-fluid main-orders-table-action"
                          align="center"
                        >
                          <p style={{ fontSize: ".75rem" }}>Total wait time</p>
                          <div className="row justify-content-center">
                            <div
                              className="col-6"
                              style={
                                {
                                  // background: "#F0F0F0 0% 0% no-repeat padding-box",
                                  // borderRadius: "6px",
                                }
                              }
                            >
                              <button
                                className="btn btn-secondary w-100 d-flex justify-content-center py-2"
                                style={{
                                  fontSize: ".75rem",
                                  background:
                                    "#F0F0F0 0% 0% no-repeat padding-box",
                                  borderRadius: "6px",
                                  color: "#000000",
                                }}
                              >
                                <img
                                  src={require("../../../../../assets/images/superadmin/ordericon/hourglass.svg")}
                                  width="15px"
                                />
                                {/* {this.props?.allData &&
                          this.props?.allData?.order_status === 7 ? (
                            <p className="font_16_m">
                              {seated_time_difference(minutesSeated)}
                            </p>
                          ) : (
                            <p className="font_16_m">00 HH : 00 min</p>
                          )} */}
                                <p className="font_16_m">
                                  {order?.seated_time_difference}
                                </p>
                              </button>
                            </div>
                          </div>
                        </div>
                      </Col>
                    </Row>
                    <hr />
                    <div className="table-responsive">
                      <table className="table desc-order-info">
                        <thead>
                          <tr
                            style={{
                              backgroundColor: "transparent",
                              borderTop: "hidden",
                            }}
                          >
                            {/* <th style={{ width: "3%" }}></th> */}
                            <th
                              className="f12-500"
                              style={{ width: "15%" }}
                              colSpan={2}
                            >
                              Order Items
                            </th>
                            <th className="f12-500" style={{ width: "3%" }}>
                              Qty
                            </th>
                            <th className="f12-500" style={{ width: "10%" }}>
                              Customization
                            </th>
                            <th className="f12-500" style={{ width: "20%" }}>
                              Personalization/ Item Notes
                            </th>
                            <th className="f12-500" style={{ width: "10%" }}>
                              Amount
                            </th>
                            <th className="f12-500" style={{ width: "10%" }}>
                              ETC
                            </th>
                            <th className="f12-500" style={{ width: "8%" }}>
                              Counter <br />
                              No.
                            </th>
                            <th className="f12-500" style={{ width: "8%" }}>
                              Substitute <br />
                              Cancel
                            </th>
                            <th style={{ width: "10%" }}>Item Status</th>
                          </tr>
                        </thead>
                        {order?.order_items.map((item, index) => (
                          <>
                            <tbody key={index}>
                              <tr>
                                <td style={{ width: "5%" }}>
                                  {ITEMTYPEVEG.map((type, index) => {
                                    return (
                                      <React.Fragment key={index}>
                                        {item?.item?.itemType ===
                                        type?.value ? (
                                          <Image
                                            width="20px"
                                            src={type.url}
                                            alt={type.title}
                                            title={type.title}
                                            fluid
                                          />
                                        ) : null}
                                      </React.Fragment>
                                    );
                                  })}
                                </td>
                                <td style={{ width: "10%" }}>
                                  {item.item.name}
                                </td>
                                <td style={{ width: "3%" }}>{item.quantity}</td>
                                <td style={{ width: "10%" }}>
                                  {" "}
                                  {item && item.addOns.length > 0 ? (
                                    getAddOns(item && item.addOns)
                                  ) : (
                                    <Fragment>N/A</Fragment>
                                  )}
                                </td>
                                <td style={{ width: "20%" }}>
                                  {item && item.customised_details
                                    ? ReactHtmlParser(
                                        prepareLevels(
                                          item && item.customised_details
                                        )
                                      )
                                    : " "}{" "}
                                  {item && item.notes}
                                </td>
                                <td style={{ width: "10%" }}>
                                  ₹ {item && item.size && item.size.price}
                                </td>
                                <td style={{ width: "10%" }}>
                                  {" "}
                                  {item && item.item && item.item.prepTime} Min
                                </td>
                                <td style={{ width: "8%" }}>
                                  {" "}
                                  {item &&
                                    item.item &&
                                    item.item.counter_number}
                                </td>
                                <td style={{ width: "8%" }}>
                                  <div class="col-12">
                                    <img
                                      src={require("../../../../../assets/images/superadmin/ordericon/uncheck.svg")}
                                      width="25px"
                                      alt="Substitute"
                                      className="mb-2"
                                    />
                                  </div>
                                </td>
                                <td style={{ width: "14%" }}>
                                  <div className="btn btn-outline-success">
                                    {order && order?.order_status === 0 ? (
                                      "Pending"
                                    ) : order?.order_status === 1 ? (
                                      "Confirmed"
                                    ) : order?.order_status === 2 ? (
                                      "Getting Prep"
                                    ) : order?.order_status === 3 &&
                                      order &&
                                      order?.order_type === 3 ? (
                                      "Food Plating"
                                    ) : order?.order_status === 3 ? (
                                      "Packing"
                                    ) : order?.order_status === 4 &&
                                      order &&
                                      order?.order_type === 3 ? (
                                      <>
                                        Ready for
                                        <br /> Dine-in
                                      </>
                                    ) : order?.order_status === 4 &&
                                      order &&
                                      order?.order_type === 0 ? (
                                      <>
                                        Ready for
                                        <br /> Take Away
                                      </>
                                    ) : order?.order_status === 4 ? (
                                      <>
                                        Ready To
                                        <br /> Pick
                                      </>
                                    ) : order?.order_status === 5 &&
                                      order &&
                                      order?.order_type === 7 ? (
                                      <>
                                        Out for
                                        <br /> Delivery
                                      </>
                                    ) : order?.order_status === 5 ? (
                                      "On The Way"
                                    ) : order?.order_status === 6 &&
                                      order &&
                                      order?.order_type === 3 ? (
                                      "Served"
                                    ) : order?.order_status === 6 ? (
                                      "Delivered"
                                    ) : order?.order_status === 7 ? (
                                      "Complete"
                                    ) : order?.order_status === 8 ? (
                                      "Cancelled"
                                    ) : null}
                                  </div>
                                  <div className="f10-400 mt-2">
                                    Current Status
                                  </div>
                                </td>
                                {/* <td style={{ width: "10%" }}>
                      
                        {item.isCancelled ||
                        order?.order_status === 8 ? (
                          "Cancelled"
                        ) : order?.order_status === 7 ? (
                          "Completed"
                        ) : (
                          <Fragment>
                            <div align="center">
                              <img
                                src={require("../../../../../assets/images/superadmin/ordericon/uncheck.svg")}
                                width="25px"
                              />
                              <br />
                              <button
                                className="btn btn-danger"
                                onClick={() =>
                                  this.onClickShowSubstituteModal(
                                    item,
                                    order?._id,
                                    index
                                  )
                                }
                              >
                                Substitute/
                                <br />
                                Cancel
                              </button>
                            </div>
                          </Fragment>
                        )}
                      </td> */}
                              </tr>
                              <hr />
                            </tbody>
                          </>
                        ))}
                        {/* <span style={{ color: "red" }}>Substituted Item</span> */}
                        {order &&
                          order?.order_items.map((item, index) => (
                            <Fragment key={index}>
                              {item.isSubstituted ? (
                                <tbody>
                                  <tr>
                                    <td style={{ width: "3%" }}>
                                      {ITEMTYPEVEG.map((type, index) => {
                                        return (
                                          <React.Fragment key={index}>
                                            {item?.item?.itemType ===
                                            type?.value ? (
                                              <Image
                                                width="20px"
                                                src={type.url}
                                                alt={type.title}
                                                title={type.title}
                                                fluid
                                              />
                                            ) : null}
                                          </React.Fragment>
                                        );
                                      })}
                                    </td>

                                    <td style={{ width: "10%" }}>
                                      {item.item.name} <br />
                                    </td>
                                    <td style={{ width: "3%" }}>
                                      {item.quantity}
                                    </td>
                                    <td style={{ width: "10%" }}>
                                      {item && item.addOns.length > 0 ? (
                                        this.getAddOns(item && item.addOns)
                                      ) : (
                                        <Fragment>N/A</Fragment>
                                      )}
                                    </td>
                                    <td
                                      className="text-break"
                                      style={{ width: "20%" }}
                                    >
                                      {item && item.customised_details
                                        ? this.prepareLevels(
                                            item && item.customised_details
                                          )
                                        : " "}{" "}
                                      {item && item.notes}
                                    </td>
                                    <td style={{ width: "10%" }}>
                                      ₹ {item && item.size && item.size.price}
                                    </td>
                                    <td style={{ width: "10%" }}>
                                      {item && item.item && item.item.prepTime}{" "}
                                      Min
                                    </td>
                                    <td style={{ width: "10%" }}>
                                      {item &&
                                        item.item &&
                                        item.item.counter_number}
                                    </td>
                                    <td style={{ width: "14%" }}>
                                      <div align="center">
                                        <img
                                          src={require("../../../../../assets/images/superadmin/ordericon/check.svg")}
                                          width="25px"
                                        />
                                      </div>
                                    </td>
                                  </tr>
                                </tbody>
                              ) : (
                                <> </>
                              )}
                            </Fragment>
                          ))}
                      </table>
                    </div>
                  </>
                )}
              </tbody>
            </table>
          </td>
        </tr>
      </tbody>
    </>
  );
};



export default OrderingPageComponent;
